import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import { propertySelectFieldFetchAllQuery } from 'components/forms/domain/property/PropertySelectField';

const useFetchAllPropertiesCalendarTools = () => {
  const { allProperties, isFetching: isFetchingProperties } =
    useFetchAllProperties({
      enabled: true,
      ...propertySelectFieldFetchAllQuery,
      operationName: 'PropertiesAllCalendarTools',
    });

  return { allProperties, isFetchingProperties };
};

export default useFetchAllPropertiesCalendarTools;
